import React, { useEffect } from 'react';
import { LayoutAlign, LayoutGap, LayoutJustify } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { any, arrayOf, node, oneOf, oneOfType, size, string, trackList } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues, getLostProps, getSlot, parseGridAreaList, propagateData } from '@philips-internal/oswald-ui-utils';
import { useForceUpdate } from '../../hooks/use-force-update.js';
import { useIsPortraitOrientation } from '../../hooks/use-is-portrait-orientation.js';
import { LayoutAPI } from './layout-api.js';
import './layout.css';
function LayoutArea(props) {
    const { uuid, name, children } = props;
    return (React.createElement(Container, { className: "c-layout__area", "data-area-name": name, exclusive: true, slot: name, style: { gridArea: name }, uuid: uuid }, children));
}
function renderSlot(slot, props) {
    const { data, children, ...otherProps } = props;
    const lostProps = getLostProps(Layout.propTypes, otherProps);
    const slotChildren = getSlot(children, slot);
    return propagateData(slotChildren, data, lostProps);
}
const LayoutContainer = {
    acceptedTypes: [
        ComponentType.BEHAVIOR,
    ],
    name: '',
};
const awesomeProps = {
    api: LayoutAPI,
    containers: [LayoutContainer],
    type: ComponentType.LAYOUT,
};
function Layout(props) {
    const isPortrait = useIsPortraitOrientation();
    const forceUpdate = useForceUpdate();
    useEffect(() => {
        forceUpdate();
    }, [isPortrait]);
    const style = {
        alignContent: props.alignContent,
        alignItems: props.alignItems,
        columnGap: props.columnGap,
        gridTemplateAreas: props.templateAreas,
        gridTemplateColumns: props.columns,
        gridTemplateRows: props.rows,
        justifyContent: props.justifyContent,
        justifyItems: props.justifyItems,
        rowGap: props.rowGap,
    };
    const areas = parseGridAreaList(props.templateAreas);
    return (React.createElement(Container, { acceptedTypes: LayoutContainer.acceptedTypes, className: "c-layout", style: style, uuid: props.uuid },
        areas.map((area) => (React.createElement(LayoutArea, { key: area.name, uuid: props.uuid, ...area }, renderSlot(area.name, props)))),
        getSlot(props.children)));
}
Layout.defaultProps = {
    alignContent: LayoutAlign.INITIAL,
    alignItems: LayoutAlign.INITIAL,
    columnGap: LayoutGap.XSMALL,
    columns: 'auto auto auto',
    justifyContent: LayoutJustify.INITIAL,
    justifyItems: LayoutJustify.INITIAL,
    rowGap: LayoutGap.XSMALL,
    rows: 'auto auto auto',
};
Layout.propTypes = {
    alignContent: oneOf(enumValues(LayoutAlign)).group('alignment'),
    alignItems: oneOf(enumValues(LayoutAlign)).group('alignment'),
    children: oneOfType([node, arrayOf(node)]).notEnumerable(),
    columnGap: size.group('layout'),
    columns: trackList,
    data: any,
    justifyContent: oneOf(enumValues(LayoutJustify)).group('alignment'),
    justifyItems: oneOf(enumValues(LayoutJustify)).group('alignment'),
    rowGap: size.group('layout'),
    rows: trackList,
    templateAreas: string.group('layout'),
    uuid: string,
};
AwesomeComponent(awesomeProps)(Layout);
export { Layout, };
//# sourceMappingURL=layout.js.map